export default __webpack_public_path__ + "29b5e37582a0ddbeac524b3d3dd5d4d6.png";